import React from 'react';
import { ProjectDetail } from '../components/projects/ProjectDetail';

interface ProjectPageProps {
  projectId: string;
  onBack: () => void;
  onProjectInfo?: (info: { name: string; matterCode?: string }) => void;
}

export const ProjectPage: React.FC<ProjectPageProps> = ({ projectId, onBack, onProjectInfo }) => {
  return <ProjectDetail projectId={projectId} onBack={onBack} onProjectInfo={onProjectInfo} />;
};
